import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'SPEC_DOC',
  title: 'Wie findet man eine Beispielvorlage des Dokuments?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Wenn Sie sich über ein abzulegendes Dokument im Unklaren sind, können Sie einfach :'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Klicken Sie auf das Dokument Ihrer Wahl, dann klicken Sie auf die Schaltfläche "Für Beispiel klicken"'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_SPEC_DOC/DE_SPEC_DOC.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Wenn Sie die Vorlage für ein Dokument nicht finden können, konsultieren Sie bitte die Vorlagen auf unserer Hilfe- und Kontaktseite.'
  }]
};
